/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { LocalizationStateInput } from '../states/localization-state';
import { LOCALIZATION_DEFAULT_LOCALE } from '../configuration/localization';
import { ensureAuthenticated } from '../utilities/is-authenticated';

/**
 * PostLocalization Input Action
 */
export class PostLocalizationInput implements Msdyn365.IActionInput {
    public userInfoInput: IPostLocalizationData;
    constructor(userInfoInput: IPostLocalizationData) {
        this.userInfoInput = userInfoInput;
    }

    public getCacheKey = () => `PostLocalizationKey`;
    public getCacheObjectType = () => 'PostLocalization';
    public dataCacheType = (): Msdyn365.CacheType => 'none';
}

export interface IPostLocalizationData {
    user: IUserInfo;
}

export interface IUserInfo {
    NumberFormat: string;
    DateFormat: string;
}

const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new PostLocalizationInput({} as IPostLocalizationData);
};

async function action(input: PostLocalizationInput, ctx: Msdyn365.IActionContext): Promise<void> {
    ensureAuthenticated(ctx);
    ctx.update(new LocalizationStateInput(), {
        dateLocale: input.userInfoInput.user.DateFormat,
        NumberLocale: input.userInfoInput.user.NumberFormat
    });

    await Msdyn365.sendRequest(
        `${ctx.requestContext.apiSettings.baseUrl}Commerce/SetUserInfo`,
        'post',
        {
            user: input.userInfoInput.user
        },
        {
            headers: {
                OUN: ctx.requestContext.apiSettings.oun,
                Authorization: `id_token ${ctx.requestContext.user.token}`,
                'Accept-Language': LOCALIZATION_DEFAULT_LOCALE
            }
        }
    );
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<void>>action,
    id: 'PostLocalization',
    input: createInput
});
